import styled from 'styled-components';
import { Heading3, P, theme } from '@ovotech/element-v5';

export const Heading = styled(Heading3)`
  color: ${theme.color.brand.dark};
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.space[400]};
`;

export const HeadingGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[400]};
  min-width: 0;
`;

export const FuelIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${theme.color.neutral[20]};
`;

export const TopupType = styled(P)`
  color: ${theme.color.surface.onSurfaceVariant};
  font-size: ${theme.font.size.sm.mediaQuery.lg};
`;

export const StatusLabel = styled(P)<{ $variant: 'info' | 'error' }>`
  color: ${({ $variant }) =>
    $variant === 'error' ? theme.color.alert.error : theme.color.alert.info};
`;

export const Amount = styled(P)`
  flex-shrink: 0;
  white-space: nowrap;
  font-size: ${theme.font.size['4xl'].mediaQuery.lg};
`;

export const DateLine = styled(P)`
  color: ${theme.color.surface.onSurfaceVariant};
`;
